import { TextField, Button } from '@mui/material';
import styled from 'styled-components';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-root': {
    minWidth: 500
  }
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: '2rem'
}));
export { StyledTextField, StyledButton };
